import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import getFullUserName from 'utils/getFullUserName';
import { hasPrivilege, USER_READ } from 'utils/privileges';
import Avatar from 'components/Avatar';
import BlockLink, { Highlight } from 'components/BlockLink';
import Flag from 'components/Flag';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserTableCell(_ref) {
  var _ref$isDeleted = _ref.isDeleted,
    isDeleted = _ref$isDeleted === void 0 ? false : _ref$isDeleted,
    id = _ref.id,
    link = _ref.link,
    email = _ref.email,
    userName = _ref.userName,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    avatarUrl = _ref.avatarUrl,
    target = _ref.target;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fullName = userName || getFullUserName({
    first_name: firstName,
    last_name: lastName
  });
  var thumbnailUrl = avatarUrl || '';
  var subtitle = [isDeleted ? t('state_deleted') : undefined, fullName ? email : undefined].filter(Boolean).join(' · ');
  return /*#__PURE__*/_jsx(BlockLink, {
    as: Link,
    to: link,
    target: target,
    isDisabled: isDeleted && !hasPrivilege(USER_READ),
    children: /*#__PURE__*/_jsxs(Flag, {
      token: isDeleted ? /*#__PURE__*/_jsx(IconDisc, {
        name: "trash",
        shady: true
      }) : /*#__PURE__*/_jsx(Avatar, {
        shady: true,
        pictureUrl: thumbnailUrl
      }),
      children: [/*#__PURE__*/_jsx(Text, {
        bold: true,
        display: "block",
        id: id.toString(),
        children: /*#__PURE__*/_jsx(Highlight, {
          children: fullName || email
        })
      }), subtitle && /*#__PURE__*/_jsx(Text, {
        dimmed: true,
        bold: false,
        size: "xs",
        children: subtitle
      })]
    })
  });
}
export default UserTableCell;